import { Typography } from "@mui/material";
import {
  borderDegug,
  lineHeightMobile,
  maxWidthWaitingList,
  styles,
} from "../../../theme/styles";
import { InputWaitingList } from "./InputWaitingList";

export const WaitingList = () => {
  return (
    <>
      <Typography
        variant="h6"
        style={{
          border: borderDegug,
          maxWidth: maxWidthWaitingList,
          fontSize: "15px",
          marginTop: "40px",
          lineHeight: lineHeightMobile,
        }}
      >
        Entre na
        <label style={styles.label}> Lista de espera </label>e seja o primeiro a
        saber sobre novos lançamentos
      </Typography>
      <InputWaitingList></InputWaitingList>
    </>
  );
};
